import React, { useEffect, useState, useContext } from 'react';
import classNames from 'classnames';
import TimeSeriesChart from 'utils/components/TimeSeriesChart/TimeSeriesChart';
import {
    useYScale,
    useBpsFormat,
} from 'utils/components/TimeSeriesChart/yAxis';
import { portfolioReturnsSeries, getLines } from './porfolioReturnsSeries';
import './PortfolioReturnsChart.scss';
import AppContext from 'app/AppContext';
import { getYDomain, PortfolioReturnsDataItem } from './portfolioReturnsData';
import { PortfolioReturnsConfigurationState } from '../store/configuration/PortfolioReturnsConfigurationState';

import { PortfolioReturnsComponentState } from '../store/component/PortfolioReturnsComponentState';

interface PortfolioReturnsContainerProps {
    combineSellsAndShorts: boolean;
    config: PortfolioReturnsConfigurationState;
    componentState: PortfolioReturnsComponentState;
    multipleSides: boolean;
    timeSeries: PortfolioReturnsDataItem[];
    width: number;
    height: number;
}

export const PortfolioReturnsChart = (
    props: PortfolioReturnsContainerProps
) => {
    const {
        combineSellsAndShorts,
        timeSeries,
        width,
        height,
        config,
        componentState,
        multipleSides,
    } = props;
    const { numberFormat } = useContext(AppContext);

    const lines = getLines(
        combineSellsAndShorts,
        config,
        componentState,
        multipleSides
    );
    const yTicks = 6;
    const yScale = useYScale(getYDomain(lines, timeSeries), [-100, 100]);
    const series = portfolioReturnsSeries(yTicks);

    const [cssClasses, setCssClasses] = useState<string>('');
    useEffect(() => {
        setCssClasses(
            classNames(
                'PortfolioReturnsChart',
                lines.includes('totalBpsValue') ? '' : 'hide-total',
                lines.includes('buyBpsValue') ? '' : 'hide-buy',
                lines.includes('sellBpsValue') ? '' : 'hide-sell',
                lines.includes('shortBpsValue') ? '' : 'hide-short',
                lines.includes('index1BpsValue') ? '' : 'hide-index1',
                lines.includes('index2BpsValue') ? '' : 'hide-index2'
            )
        );
    }, [lines, config.showMarketSessionTimes]);

    const bpsFormat = useBpsFormat(numberFormat);

    return (
        <div
            className={cssClasses}
            style={{ width: width + 'px', height: height + 'px' }}
        >
            <TimeSeriesChart
                id="PortfolioReturnsChart"
                height={height}
                data={timeSeries}
                series={series}
                displayXAxis={true}
                yScale={yScale}
                yTicks={yTicks}
                yTickFormat={bpsFormat}
            />
        </div>
    );
};
